import { usePathname, useSearchParams } from 'next/navigation'

export const useHref__CLIENT_ONLY = () => {
  const pathname = usePathname()
  const searchParams = useSearchParams().toString()

  return `${pathname}${searchParams ? `?${searchParams}` : ''}`
}
